import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";

const EditSubDepartment = ({ show, onClose, refresh, data }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [selDept, setSelDept] = useState(null);
    const [selDeptOPT, setSelDeptOPT] = useState(null);
    const [subDeptName, setSubDeptName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});

    const [deptOpt, setDeptOpt] = useState([]);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/get_department`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.department_name,
                }));
                setDeptOpt(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    useEffect(() => {
        if (data && deptOpt) {
            setSelDept(deptOpt.find(opt => opt.value == data.department_id)?.value || null);
            setSelDeptOPT(deptOpt.find(opt => opt.value == data.department_id) || null);
            setSubDeptName(data.sub_department_name);
            setDescription(data.description);
        }
    }, [data, deptOpt]);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [data_name, setData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/sub_department/getall`)
            .then(response => {
                setData(response.data.filter(item => item.sno !== data.sno).map(mode => mode.sub_department_name.toLowerCase()));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;

        if (!subDeptName.trim()) {
            newErrors.name = "This Field is Required.";
        } else if (!regex.test(subDeptName)) {
            newErrors.name = "Not a Valid Name";
        } else if (data_name.includes(subDeptName.trim().toLowerCase())) {
            newErrors.name = "This Name Already Exists";
        }

        if (!selDept) {
            newErrors.dept = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            department_id: selDept,
            sub_department_name: subDeptName,
            description: description
        };

        axios.put(`${baseURL}/sub_department/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Sub Department Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Sub Department Updation Failed");
            });
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Department</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department <span className="required">*</span></label>
                            <Select placeholder="Select Department" options={deptOpt} value={selDeptOPT} onChange={(e) => {
                                    setSelDept(e.value);
                                    setSelDeptOPT(e);
                                }}
                            />
                            {errors.dept && (<div className="text-danger">{errors.dept}</div>)}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Sub Department Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Department"
                                maxLength={100}
                                value={subDeptName}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setSubDeptName(formatName(onlyAlphabets));
                                }}
                            />
                            {errors.name && (<div className="text-danger">{errors.name}</div>)}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className="form-control h-auto" name="comment" placeholder="Description"
                                maxLength={250}
                                value={description}
                                onChange={(e) => setDescription(formatName(e.target.value))}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Department
                            <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditSubDepartment;
